/**
 * Created by kevinqueeney on 24/07/2015.
 */
angular.module('qkr.tax').controller('TaxSettingsController', ['$scope', 'merchant', 'outlets', 'taxRegionOverrideList',
    'merchantService', 'taxService', 'messageService', 'gettextCatalog',
    function($scope, merchant, outlets, taxRegionOverrideList, merchantService, taxService,
             messageService, gettextCatalog) {
    $scope.merchant = merchant;
    $scope.customRegionTaxList = [];
    $scope.saving = false;

    $scope.merchantTaxSettings = {
        taxCalculationsEnabled: false,
        pricesSetPretax: false
    };

    $scope.taxEnabledToggled = function() {
        if ($scope.merchantTaxSettings.taxCalculationsEnabled) {
            $scope.merchantTaxSettings.pricesSetPretax = false;
            $scope.merchantTaxSettings.totalTaxAmountProvided = false;
            $scope.merchantTaxSettings.taxName = null;
            $scope.merchantTaxSettings.taxRate = 0;
        }
    };

    $scope.totalTaxAmountProvidedToggled = function() {
        if ($scope.merchantTaxSettings.totalTaxAmountProvided) {
            $scope.merchantTaxSettings.taxName = null;
            $scope.merchantTaxSettings.taxRate = 0;
        }
    };

    $scope.save = function() {
        $scope.saving = true;

        taxService.updateTaxSettingsForMerchant($scope.merchantTaxSettings).then((merchant) => {
            $scope.merchant = merchantService.refreshMerchantInfoWithMerchant(merchant);
            messageService.saveAlert();
            $scope.taxSettings.$setPristine(true);
            $scope.saving = false;
        }, (response) => {
            $scope.taxSettings.$setPristine(true);
            $scope.saving = false;
        });
    };

    const init = function() {
        if ($scope.merchant != null) {
            $scope.merchantTaxSettings.taxCalculationsEnabled = $scope.merchant.taxCalculationsEnabled !== null ?
                $scope.merchant.taxCalculationsEnabled : false;
            $scope.merchantTaxSettings.pricesSetPretax = $scope.merchant.pricesSetPretax !== null ?
                $scope.merchant.pricesSetPretax : false;

            $scope.customRegionTaxList = getExistingCustomRegionTaxList(taxRegionOverrideList);
            const existingRegionList = getExistingOutletRegionList(outlets);

            $scope.merchantTaxSettings.totalTaxAmountProvided = $scope.merchant.totalTaxAmountProvided;
            $scope.merchantTaxSettings.taxName = $scope.merchant.taxName;
            $scope.merchantTaxSettings.taxRate = $scope.merchant.taxRate;

            generateCustomRegionTaxForExistingRegions($scope.merchant, $scope.customRegionTaxList, existingRegionList);
        }
    };

    var getExistingOutletRegionList = function(outletList) {
        const outletRegionList = [];

        if (outletList != null) {
            angular.forEach(outletList, (outlet) => {
                if (outlet.contactDetails != null && outlet.contactDetails.state != null) {
                    let regionAlreadyInList = false;
                    for (let i = 0; i < outletRegionList.length; i++) {
                        const region = outletRegionList[i];
                        if (region == outlet.contactDetails.state) {
                            regionAlreadyInList = true;
                            break;
                        }
                    }

                    if (!regionAlreadyInList) {
                        outletRegionList.push(outlet.contactDetails.state);
                    }
                }
            });
        }

        return outletRegionList;
    };

    var getExistingCustomRegionTaxList = function(taxRegionOverrideList) {
        const customRegionTaxList = [];

        if ($scope.merchant.contactDetails != null && $scope.merchant.contactDetails.country != null) {
            if ($scope.merchant.contactDetails.country.taxationMerchantRegionOverride && taxRegionOverrideList != null) {
                angular.forEach(taxRegionOverrideList, (taxRegionOverride) => {
                    customRegionTaxList.push(taxService.convertDiscriminatedTaxRateToCustomRegionTax(taxRegionOverride));
                });
            }
        }

        return customRegionTaxList;
    };

    var generateCustomRegionTaxForExistingRegions = function(merchant, customRegionTaxList, existingRegionList) {
        const nonExistentCustomRegionTaxList = [];
        angular.forEach(existingRegionList, (region) => {
            if (!findCustomRegionTaxInList(customRegionTaxList, region) && !findCustomRegionTaxInList(nonExistentCustomRegionTaxList, region)) {
                const nonExistentCustomRegionTax = createCustomRegionTaxForMerchantAndRegion(merchant, region);
                nonExistentCustomRegionTaxList.push(nonExistentCustomRegionTax);
            }
        });

        angular.forEach(nonExistentCustomRegionTaxList, (nonExistentCustomRegionTax) => {
            customRegionTaxList.push(nonExistentCustomRegionTax);
        });
    };

    var createCustomRegionTaxForMerchantAndRegion = function(merchant, region) {
        let taxName = '';
        if (merchant != null && merchant.contactDetails != null && merchant.contactDetails.country != null) {
            taxName = merchant.contactDetails.country.defaultSalesTaxName;
        }

        return {
            exists: false,
            name: taxName,
            region,
            rate: null
        };
    };

    var findCustomRegionTaxInList = function(customRegionTaxList, region) {
        let foundRegion = false;

        for (let i = 0; i < customRegionTaxList.length; i++) {
            const customRegionTax = customRegionTaxList[i];
            if (customRegionTax.region == region) {
                foundRegion = true;
            }
        }

        return foundRegion;
    };

    init();
}]);



// WEBPACK FOOTER //
// ./src/tax/controllers/tax.settings.controller.js